var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-type-dropdown-component",class:[{'is-open' : _vm.open}]},[_c('ul',_vm._l((_vm.productTypes),function(type){return _c('li',{key:type.id},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.selectProductType(type)}}},[_vm._v(_vm._s(type.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }